import { ActivityType } from 'constants/activities';

import { ActivitiesGroup } from '../Activities.constants';

export const activityFilterTypesToGroups = {
  [ActivitiesGroup.COMMUNICATION]: [ActivityType.EMAIL, ActivityType.CALL],
};

export const ActivityFilterGroup = {
  [ActivitiesGroup.COMMUNICATION]: 'Communication',
};

export const ActivityFilterType = {
  [ActivityType.EMAIL]: 'Emails',
  [ActivityType.CALL]: 'Calls',
};

export const getAvailableActivityTypes = isCallsEnabled => [
  ActivityType.EMAIL,
  ...(isCallsEnabled ? [ActivityType.CALL] : []),
];
